import createIsDirty from './selectors/isDirty';
import plain from './structure/plain';
export default createIsDirty(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/isDirty.js
// module id = vQf+
// module chunks = 1